'use client';

import { BundleCardCta } from '@components/templates/employer/job-bundles/cards/BundleCardCta';
import { BundleBenefits } from './BundleBenefits';
import { CardAgencyBadge } from './CardAgencyBadge';

/**
 * @description Agency card - displayed as the 4th option in the offer page
 */
interface AgencyCardProps {
  bundleData?: ApiSchema<'OfferBundle'>;
}

export const AgencyCard = (props: AgencyCardProps) => {
  const { bundleData } = props;

  // Fallback to translations if bundleData is missing
  const title = bundleData?.title;
  const benefits = bundleData?.benefits;

  return (
    <div className="relative flex h-full flex-col rounded-md border bg-surface p-5">
      <CardAgencyBadge />
      <div className="min-h-10 leading-snug">
        <h5 className="text-lg font-bold">
          {title}
        </h5>
      </div>

      <div className="mt-3 flex-1 overflow-hidden">
        <BundleBenefits benefits={benefits} />
      </div>

      <BundleCardCta bundleData={bundleData} />
    </div>
  );
};
